export const linkifyOptions = {
  target: { url: '_blank' },
  attributes: { rel: 'noopener noreferrer nofollow' },
};
